/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Voltar",
      "<h3 class=”header-3”>Estado da Acessibilidade</h3> <p>A Lei Europeia da Acessibilidade exige que concebamos os nossos serviços de comércio eletrónico (incluindo métodos de identificação e pagamento) tendo em consideração a acessibilidade, para que sejam percetíveis, operáveis, compreensíveis e robustos. Além disso, procuramos conceber os nossos websites e aplicações móveis de acordo com as <a href=\"https://www.w3.org/WAI/standards-guidelines/wcag/\" target=\"_blank\">Diretrizes de Acessibilidade para Conteúdo Web 2.1 do W3C, Nível AA</a>. Para alcançar estes objetivos, fizemos o seguinte: </p> <ul> <li>Estabelecemos parceria com consultorias de acessibilidade como a Level Access para compreender como podemos tornar os nossos serviços mais acessíveis.</li> <li>Avaliámos as nossas experiências digitais em relação a normas globais de acessibilidade.</li> <li>Aprendemos com uma equipa diversa de especialistas em acessibilidade, incluindo utilizadores com deficiência e outras necessidades adicionais de acessibilidade.</li> </ul>",
      "<h3 class=”header-3”>Feedback e Contacto</h3> <p>Embora procuremos garantir acessibilidade para todos os utilizadores, podem existir algumas limitações. Agradecemos o teu feedback para nos ajudar a melhorar o nosso serviço, por isso, se encontrares barreiras de acessibilidade ou precisares de informação num formato alternativo, contacta-nos através de accessibility@bumble.com.</p>",
      "<h3 class=”header-3”>Melhorias Futuras</h3> <p>O nosso trabalho em acessibilidade está em curso. Continuaremos a:</p> <ul> <li>Monitorizar e rever a acessibilidade em todas as plataformas digitais.</li> <li>Corrigir problemas conhecidos e prevenir futuras barreiras no nosso design tendo a acessibilidade em mente.</li> <li>Expandir a formação interna e a sensibilização para melhorar as práticas de design inclusivo.</li> </ul>",
      "<h3 class=”header-3”>Última atualização: novembro de 2025</h3>",
      "<h3 class=”header-3”>Medidas Adotadas</h3> <p>Para melhorar a acessibilidade nos nossos serviços, fizemos o seguinte:</p> <ul> <li>Estabelecemos parceria com a Level Access para realizar avaliações abrangentes de acessibilidade e receber orientação especializada.</li> <li>Integrámos ferramentas de acessibilidade nas nossas plataformas, incluindo tecnologias assistivas como alternativas ao teclado, ativação por voz e navegação sem toque.</li> <li>Realizámos testes com utilizadores com deficiência para recolher feedback real e orientar melhorias.</li> <li>Integrámos considerações de acessibilidade no ciclo de desenvolvimento de produto e nos processos de garantia de qualidade.</li> <li>Estabelecemos um programa de acessibilidade digital em toda a organização.</li> <li>Implementámos uma <a href=\"https://www.levelaccess.com/bumble/\" target=\"_blank\">plataforma assistiva de experiência do cliente</a>. Esta é gratuita e está disponível para pessoas que tenham dificuldade em escrever, fazer gestos, mover um rato ou ler. Inclui ferramentas como substituições de rato e teclado, reconhecimento de voz, ativação de fala, navegação mãos-livres/sem toque e muito mais.</li> </ul>",
      "<h3 class=”header-3”>A nossa política</h3> <p>No Bumble, a equidade está no centro dos nossos valores. Para nós, essa é muito mais do que uma palavra da moda pois estamos empenhados em tornar as experiências no Bumble acessíveis, justas e equitativas.</p> <p>Esta declaração de acessibilidade foi preparada para informar os nossos utilizadores sobre a acessibilidade do nosso serviço, incluindo a sua conformidade com normas legais e técnicas relevantes. Esta declaração de acessibilidade aplica-se aos elementos dos nossos serviços [RS2] abrangidos pela Lei Europeia da Acessibilidade, em particular aos nossos serviços de comércio eletrónico, que permitem aos utilizadores atualizar para uma gama de funcionalidades melhoradas e premium do Bumble. Estes serviços podem ser acedidos através da aplicação do Bumble.</p>",
      "Declaração de Acessibilidade Europeia",
      "Descarregar na App Store",
      "Obter no Google Play",
      "Carrossel",
      "Slide {{number}}",
      "Próximo slide",
      "Slide anterior",
      "Slide",
      "Slide {{number}} de {{total}}",
      "Não vender nem partilhar as minhas informações pessoais",
      "Não vender nem partilhar as minhas informações pessoais",
      "Envia elogios no Bumble para mostrares o teu apreço por um perfil e chamares a atenção antes de te ligares. Experimenta já",
      "Compliments | Como enviar um elogio | Bumble",
      "Uma página personalizada que destaca as pessoas mais compatíveis contigo, atualizada diariamente.",
      "Descobre | Encontra pessoas compatíveis | Bumble",
      "Utiliza o Modo Invisível para teres total controlo sobre os teus encontros e quem vê o teu perfil do Bumble. Consulta o nosso guia para saberes como utilizar o Modo Invisível do Bumble",
      "Modo Invisível | Oculta o perfil | Bumble",
      "Depois de conheceres alguém num encontro do Bumble, podes continuar a conversa na app.",
      "Ligação imediata | Continua a conversar na aplicação | Bumble",
      "Precisas de uma pequena pausa ou de algum tempo para ti? Descobre como congelar a tua conta do Bumble com o modo Não perturbar do Bumble. O controlo é todo teu.",
      "Modo Não perturbar | Pausar a conta | Bumble",
      "Viste alguém que te agrada no Bumble? Usa um SuperSwipe para mostrar o teu apreço. Toca na estrela do perfil que gostas para começar ou vê mais detalhes aqui",
      "SuperSwipe do Bumble | O que é um SuperSwipe? | Bumble",
      "Vais viajar em trabalho ou por lazer? O Modo Viagem do Bumble ajuda-te a fazer novas e divertidas ligações e a encontrares-te onde quer que estejas. Usa já o Modo Viagem",
      "Modo Viagem do Bumble | Encontra-te onde quer que estejas | Bumble",
      "Queres saber se a ligação que estás a sentir nas mensagens corresponde ao que vais sentir em pessoa? Faz uma já chamada ou videochamada no Bumble para teres uma ideia do potencial da ligação.",
      "Videochamada | Fazer uma chamada | Bumble",
      "Bumble Date",
      "Aplicações",
      "Quem somos",
      "Empregos",
      "Entra em contacto",
      "Investidores",
      "Loja",
      "Empresa",
      "Instalar a aplicação",
      "Acessibilidade no Bumble",
      "Regras",
      "Gestão de cookies",
      "Lei contra a escravidão moderna",
      "Notificação de recolha de dados",
      "Política de privacidade",
      "Termos e condições",
      "Aspetos legais",
      "Política de privacidade dos dados de saúde do consumidor de Washington",
      "Lê o código QR para instalares a aplicação do Bumble",
      "Iniciar sessão",
      "Terminar aqui os contratos",
      "Descarregar já",
      "Lê o código QR para começar.",
      "Encontra a próxima ligação",
      "Obtém a aplicação",
      "Página inicial do Bumble",
      "Fechar menu",
      "Abrir menu",
      "Em Breve: Histórias de Amor no Bumble",
      "Escolhe a tua língua",
      "Seleção de idioma",
      "Rodapé",
      "Acessibilidade no Bumble",
      "A Apple e o logótipo da Apple são marcas registadas da Apple Inc.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Vagas",
      "Eventos",
      "Google Play é uma marca comercial da Google LLC.",
      "Regras",
      "Investidores",
      "Gerir Cookies",
      "Gerir Cookies",
      "Lei sobre Escravatura Moderna",
      "Notificação de recolha de dados",
      "Política de Privacidade",
      "Guias sazonais de encontros",
      "Termos e Condições",
      "App",
      "Política de privacidade dos dados de saúde do consumidor de Washington",
      "Sobre",
      "Embaixadores",
      "Faz amizades e encontra a tua comunidade",
      "Liga-te a profissionais e avança na carreira",
      "Encontra uma relação séria, casual ou algo entre uma e a outra.",
      "O Buzz",
      "Saber mais",
      "Vê o mundo com o Modo Viagem",
      "Date",
      "Eventos",
      "Recursos",
      "Compliments",
      "Utiliza o Compliments para te destacares das multidões.",
      "Descobre",
      "Uma página personalizada que destaca as pessoas mais compatíveis contigo, atualizada diariamente.",
      "Modo Invisível",
      "Usa o Modo Invisível para ocultar o perfil do patrão, ex ou dos parentes.",
      "Ligação imediata",
      "Começaste uma conversa num encontro do Bumble? Continua a conversar na app.",
      "Modo Não Perturbar",
      "Faz uma pausa com o Não Perturbar. Quando quiseres voltar, sabes onde nos encontrar.",
      "SuperSwipe",
      "O perfil passou a prova dos nove? Diz-lhe com um SuperSwipe.",
      "Modo Viagem",
      "Encontra a tua felicidade em qualquer parte do mundo com o Modo Viagem.",
      "Videochamada",
      "Utiliza o videochat e as videochamadas para veres se estão prontos para se encontrarem em pessoa.",
      "Obtém a app do Bumble",
      "BFF",
      "Segurança",
      "Histórias",
      "Apoio",
      "Loja",
      "Navegação principal",
      "Utiliza o Compliments para te destacares das multidões.",
      "Compliments",
      "Recursos criados para fomentar ligações reais, respeitosas e significativas.",
      "Usa o Modo Invisível para ocultar o perfil do patrão, ex ou de familiares.",
      "Modo Invisível",
      "Faz uma pausa dos encontros com o Não perturbar.",
      "Modo Não perturbar",
      "Viste alguém que te agradou? Não deixes escapar o momento.",
      "SuperSwipe",
      "Explora o Date",
      "Liga-te onde quer que estejas.",
      "Modo Viagem",
      "Vê e interage com as ligações antes de se encontrarem.",
      "Videochamadas",
      "Experimenta o Bumble diretamente no teu navegador.",
      "Aplicação web",
      "Líderes que ajudam a transmitir os valores do Bumble para as comunidades por todo o país.",
      "Líderes da comunidade",
      "Recursos criados para te ligares e encontrares pessoas com interesses em comum.",
      "Organiza um encontro em grupo ou encontra eventos perto de ti.",
      "Plans",
      "Explorar o BFF",
      "Toda a orientação e inspiração de que necessitas para encontrares amor e amizade.",
      "Conselhos e histórias para construíres as amizades que tens em mente.",
      "O espaço da amizade",
      "De Tóquio a Toronto, explora os casos de sucesso do Bumble por todo o mundo.",
      "Histórias de amor",
      "Planeia um encontro perfeito — independentemente do dia, local ou pessoa.",
      "Guias sazonais de encontros",
      "Lê histórias",
      "Ir para conteúdo principal",
      "Logotipo do Bumble",
      "Fechar menu de navegação",
      "Abrir menu de navegação",
      "Retrato de Whitney Wolfe Herd, fundadora e CEO do Bumble",
      "Whitney Wolfe Herd fundou o Bumble com um objetivo: criar um espaço seguro para encontrar o amor, onde as mulheres dão o primeiro passo e as ligações se baseiam no respeito. {{__EOL__}}{{__EOL__}}No papel de CEO, continua a liderar com a mesma convicção: que encontrar o amor online deve ser uma experiência intencional, segura e autêntica. O Bumble é mais do que apenas encontros — ajuda as pessoas a encontrar o que realmente é importante, com cuidado, intenção e coragem. Para isso, utiliza tecnologia e IA para aprofundar as ligações humanas, e não para as substituir. Estamos a aproveitar tudo o que aprendemos — o bom, o menos bom e tudo o que é real — para que toda a comunidade se continue a sentir bem-vinda no Bumble.",
      "Whitney Wolfe Herd",
      "Casal sorridente a inclinar-se para um beijo e de mãos dadas no banco de trás de um carro, com verdura no exterior.",
      "Acreditamos que o amor — em todas as suas formas — é a fundação de uma vida feliz e saudável.",
      "Olá. Somos a Love Company.",
      "Ecrã de ligação do Bumble com dois perfis e um aviso para iniciar a conversa.",
      "O resultado é uma plataforma focada nos seus membros, projetada para criar ligações amáveis e saudáveis.",
      "Em {{date}}, redefinimos as regras dos encontros.",
      "A nossa missão é aproximar as pessoas do amor.",
      "A nossa missão",
      "Invertemos as convenções dos encontros, dando às mulheres a possibilidade de dar o primeiro passo.",
      "Nasce o Bumble",
      "O {{bff}} surgiu para ajudar as pessoas a encontrarem a sua tribo. Porque o amor também pode ser platónico.",
      "Fomos além dos encontros",
      "A Serena Williams ajudou-nos a levar as mulheres que dão o primeiro passo à Super Bowl.",
      "Estreia na Super Bowl",
      "Lançámos novos recursos para facilitar ligações durante a pandemia de Covid-19.",
      "Os encontros tornam-se virtuais",
      "Tornámo-nos uma empresa cotada — liderados pela mulher mais jovem de sempre a fazê-lo.",
      "Fez-se história",
      "A par da nossa tecnologia anti-cyberflashing, alargámos as nossas políticas para proteger as mulheres.",
      "Mais segurança",
      "Demos ao desporto feminino o destaque que ele merece.",
      "WNBA x Bumble",
      "Agora, estamos a construir um futuro onde amar é possível para todos.",
      "A liderar com amor",
      "Tudo começou com um passo corajoso. Agora, estamos a criar o lugar mais fidedigno e eficaz para encontrar o amor.",
      "Desliza para explorar",
      "Desliza para a esquerda",
      "Desliza para a direita",
      "A nossa história",
      "Ver vagas",
      "Ajuda-nos a criar um espaço seguro para encontrar o amor.",
      "Vem trabalhar connosco",
      "Ecrãs da aplicação BFF a destacar a visualização do perfil do utilizador e os crachás de interesses para facilitar a ligação com amigos.",
      "Se te mudaste para uma nova cidade ou simplesmente queres expandir o teu círculo social, o {{bff}} é a forma mais fácil de conhecer pessoas compatíveis na mesma onda que tu.",
      "Encontrar a minha tribo",
      "Colagem de perfis do Bumble a mostrar várias pessoas com crachás de verificação de identidade, incluindo uma mulher a tirar uma selfie ao espelho no centro.",
      "Quer estejas a dar os primeiros passos no mundo dos encontros ou a tentar novamente, o Bumble Date foi criado para te aproximar do amor de forma segura e significativa.",
      "Encontrar a tua pessoa",
      "Mulher sorridente com um skate num parque",
      "Ar livre",
      "Homem a correr e a sorrir num parque urbano",
      "Correr",
      "Mulher a segurar um cão pequeno ao ar livre",
      "Tenho um cão",
      "Descarregar o Bumble",
      "Queremos que os nossos membros encontrem relações significativas e autênticas que despertem confiança e otimismo.",
      "Existimos para aproximar as pessoas do amor.",
      "Mulher com um longo rabo de cavalo escuro, top preto e óculos de sol na cabeça, a sorrir com o mar como pano de fundo.",
      "Homem com barba, de camisa às riscas, a segurar uma máquina fotográfica, em pé, ao ar livre, com árvores e edifícios ao fundo.",
      "Mulher com um casaco vermelho com riscas arco-íris e auscultadores prateados, a usar um colar com uma estrela verde, a olhar para a câmara.",
      "Casal sorridente abraçado num retrato em preto e branco",
      "{{name1}} e {{name2}}, casados em {{num}}",
      "Saber mais",
      "Ler mais histórias",
      "\"{{__EOL__}}Somos ambos naturalmente positivos e determinados, mas, quando estamos juntos, parece que não há nada que não consigamos alcançar.",
      "Duas pessoas a rir num corte de ténis; uma delas segura bolas de ténis sobre os olhos",
      "Conhecer em pessoa",
      "Os eventos presenciais do Bumble permitem-te parar de escrever e começar a conversar. Aparece com ou sem companhia e encontra novas ligações.",
      "Começa a conversa em pessoa",
      "Pessoas as desfrutarem de ligações no Bumble através de fotos, videochamadas e conselhos de especialistas.",
      "Inscrever-me",
      "Ajuda a moldar o futuro do Bumble ao aderir ao nosso Círculo de Membros. Esta comunidade selecionada de membros partilha ideias diretamente com a nossa equipa através de conversas, discussões e testes de produtos.{{__EOL__}}{{__EOL__}}Os participantes têm acesso antecipado a novas funcionalidades, vislumbres de campanhas futuras e a oportunidade de ajudar a tornar Bumble ainda melhor para todos.",
      "Partilha as tuas ideias",
      "Queres conhecer melhor alguém? Usa as videochamadas no Bumble",
      "As videochamadas são efetuadas através do ícone de vídeo, no chat, sem ser necessário partilhar dados de contacto.",
      "Como funcionam as videochamadas no Bumble?",
      "Não. No Bumble, os dados pessoais dos membros não são divulgados em chamadas ou conversas. O teu número ou qualquer outro dado de contacto apenas serão divulgados por ti.",
      "A minha ligação pode ver o meu número de telemóvel?",
      "Sem dúvida! Se ainda não te sentires à vontade para conhecer alguém em pessoa, faz uma chamada por áudio. Só tens de selecionar o ícone de chamada.",
      "Posso ligar a alguém?",
      "É tão bom receber uma boa notificação de *mensagem recebida*. Mas pode ser difícil distinguir se a conversa valerá a pena em pessoa. É aí que entram as chamadas por vídeo e áudio.",
      "Videochamadas no Bumble",
      "As <a href={{video_chat_url}}>chamadas por vídeo e áudio</a> ajudam-te a conhecer alguém melhor e decidir se vale a pena avançar com a relação fora da aplicação. O melhor de tudo é que para fazer uma videochamada não é necessário trocar números de telemóvel. Por isso, os teus dados pessoais estarão seguros até que tu os decidas partilhar.",
      "Vê se há química com as videochamadas",
      "É como um meio caminho entre os encontros online e offline. Ideal para ver se está na altura de se encontrarem em pessoa.",
      "Conhece melhor alguém (e mais rápido). As conversas por vídeo ou áudio são muito reveladoras.",
      "O controlo é teu. Os teus dados de contacto não são divulgados, és tu que decides quando os queres partilhar.",
      "Ver se te queres encontrar em pessoa",
      "Ver se há química",
      "Ligar sem divulgar dados pessoais",
      "Razões para usar as chamadas por áudio e vídeo",
      "Queres começar a conversar? Opta por fazer uma chamada por áudio ou vídeo diretamente no chat da aplicação do Bumble. Para fazer uma videochamada, toca no ícone cinzento da câmara, no canto superior direito. Ao lado do ícone verás também três pontos, clica neles para veres a opção de chamada por áudio.",
      "Como fazer uma videochamada",
      "Vamos experimentar o Compliments?",
      "Quando envias um elogio, a pessoa que o recebe irá vê-lo quando tu apareceres na sua fila.",
      "O que acontece quando elogio alguém no Bumble?",
      "Se o elogio de alguém te tiver despertado o interesse, não hesites em criar uma ligação. O elogio vai aparecer no chat e as regras habituais do <a href={{make_the_first_move_url}}>primeiro passo</a> continuarão a valer.",
      "Como é que respondo a um elogio?",
      "Podes enviar {{num}} [[Compliments:num]] gratuitamente. Se não tiveres mais, podes comprar pacotes com um máximo de 30 Compliments na app do Bumble. Um deles será utilizado para enviar o elogio que querias enviar (o resto será reservado até que vejas um perfil que te agrada). Não te preocupes, eles não expiram!",
      "Quantos Compliments posso enviar?",
      "Uma palavra amável (ou duas) pode ir muito longe. Se queres enviar um elogio, mas te falta a coragem, inspira-te num destes:",
      "Ver mais exemplos",
      "“Já vi que gostas de [nome do artista], é sinal de bom gosto.”",
      "\"Tens um sorriso contagioso!\"",
      "“A tua biografia fez-me rir. Estiveste bem.”",
      "Como enviar elogios melhores no Bumble",
      "Queres alegrar o dia de alguém? Então, usa o Compliments.",
      "Compliments no Bumble",
      "Usa o Compliments do Bumble para mostrar o teu apreço por alguém (e fazer alguém corar). O Compliments faz parte do {{service_level_lexeme_name}}. E é também uma forma de enviar e receber mensagens antes de fazer uma ligação.",
      "Como funciona o Compliments",
      "Quando recebes um elogio, ele aparece no perfil do remetente. Também recebes uma notificação a informar-te de que alguém gosta de uma parte do teu perfil.",
      "Vê os teus elogios",
      "Podes enviar um elogio tocando no ícone amarelo do coração, na parte inferior do perfil de alguém. Onde tocas é importante, porque estarás a elogiar aquela foto ou uma parte específica do perfil! Quando clicas, abre-se uma caixa de texto para que possas escrever a tua mensagem (não podes exceder os 150 caracteres).",
      "Enviar um elogio",
      "DESCARREGA O Bumble PARA EXPERIMENTARES JÁ O DESCOBRE",
      "A página do Descobre é atualizada todos os dias, às 09:00. As pessoas que lá aparecem são sugeridas com base em interesses em comum.",
      "Quando é que a página do Descobre é atualizada?",
      "A página do Descobre organiza as possíveis ligações em 3 categorias principais: interesses e objetivos semelhantes e comunidades em comum. As recomendações de perfil são feitas com base em ligações anteriores.",
      "Como são selecionadas as pessoas que aparecem no Descobre?",
      "Uma página personalizada que destaca as pessoas mais compatíveis contigo, atualizada diariamente",
      "ENCONTRA PESSOAS NA MESMA ONDA QUE TU COM O {{qr_code}} DESCOBRE",
      "O Descobre mostra-te uma seleção de pessoas que poderão ser compatíveis contigo, com base em interesses, intenções e comunidades semelhantes.",
      "Experimentar o Descobre",
      "QUERES ENCONTRAR PESSOAS COM COISAS EM COMUM?",
      "O Descobre é atualizado todos os dias para passares menos tempo à procura de ligações e mais tempo a conhecer pessoas na mesma onda que tu.",
      "NOVAS RECOMENDAÇÕES TODOS OS DIAS",
      "As recomendações do Descobre baseiam-se no teu perfil e em ligações anteriores, pelo que verás pessoas com interesses e intenções semelhantes — quer estes sejam comida vegana ou uma relação séria.",
      "PERSONALIZADO{{__EOL__}}E À TUA MEDIDA",
      "Descarregar o Bumble",
      "Perguntas Frequentes",
      "Queres navegar pelo Bumble sem que te vejam?",
      "Quando ativas o Modo Invisível, não apareces a outros membros do Bumble a menos que gostes do seu perfil.",
      "Como funciona o Modo Invisível?",
      "Sem o Modo Invisível, o teu perfil aparece aos outros no Bumble quando correspondes às suas preferências, como idade e localização. Quando ativas o Modo Invisível, apareces apenas a pessoas de quem gostaste.",
      "Quem é que me pode ver no Modo Invisível do Bumble?",
      "O Modo Invisível não é o mesmo que <a href={{blocking_on_bumble_url}}>bloquear alguém</a>. Com este recurso, se gostares de alguém (ou se já tiveres enviado mensagens a essa pessoa), essa pessoa poderá ver o teu perfil.",
      "O Modo Invisível é como bloquear alguém?",
      "Controla quem vê o teu perfil com o Modo Invisível do Bumble.",
      "Modo Invisível do Bumble",
      "Se queres fazer uma pausa dos encontros ou navegar pelo Bumble sem que o teu perfil seja visto, podes ativar o Modo Invisível. Este recurso permite-te ocultar o perfil, a menos que gostes de alguém primeiro. Permite-te também controlar o que partilhas e quem te vê.",
      "Oculta o perfil com o Modo Invisível",
      "És tu que decides quem pode ver as tuas fotos e dados pessoais.",
      "Queres adicionar algo pessoal ao teu perfil? Partilha discretamente o que quiseres com as tuas ligações atuais.",
      "Navega livremente, sem te preocupares se encontras um ex, colega de trabalho ou qualquer outra pessoa que não esteja no teu radar de encontros.",
      "O controlo é totalmente teu",
      "Escolhe aquilo que partilhas",
      "Evita encontros embaraçosos",
      "Razões para adorar o Modo Invisível",
      "O Modo Invisível é disponibilizado aos membros do {{service_level_lexeme_name}} e {{service_level_lexeme_name_two}}. Quando assinares, podes ativá-lo no separador do perfil, tocando em “definições” no canto superior direito.",
      "Ativar o {{service_level_lexeme_name}}",
      "Como usar o Modo Invisível no Bumble",
      "DESCARREGA O Bumble PARA TE LIGARES IMEDIATAMENTE",
      "Na app do Bumble, vai ao perfil na parte inferior do ecrã. Aí, na parte superior direita do ecrã, encontras o ícone do código QR. Toca nele para teres acesso.",
      "Onde está o código QR pessoal?",
      "Não. O código QR mais atualizado da ligação imediata apenas funciona quando estás ligado(a) à internet, seja através de dados móveis ou Wi-Fi.",
      "Posso partilhar uma imagem de ecrã do código QR para fazer uma ligação?",
      "Não. O código apenas tem de ser lido por uma das pessoas para a ligação ser feita.",
      "O código tem de ser lido por ambas as pessoas?",
      "Com as ligações imediatas, podes ver logo o que é que tu e a tua nova ligação têm em comum. Desta forma, tens logo uma ideia do seu nível de compatibilidade.",
      "DESCOBRE LOGO O QUE TÊM EM COMUM",
      "Começaste uma conversa num evento presencial do Bumble? Continua a conversar na app.",
      "TRANSFORMA AQUELE ENCONTRO INTERESSANTE NUMA LIGAÇÃO IMEDIATA {{qr_code}}",
      "A ligação imediata ajuda-te a continuar a conversa com aquela pessoa gira que encontraste na vida real, mas sem trocar perfis sociais ou números de telemóvel. Só tens de lhe pedir que leia o teu código QR para te ligares no Bumble.",
      "Experimentar a ligação imediata",
      "CONHECESTE ALGUÉM NUM ENCONTRO DO Bumble?",
      "A ligação imediata permite-te ter primeiro uma ideia da pessoa que está do outro lado, através da app, antes de trocarem perfis sociais ou números de telemóvel. Assim, podes tomar o teu tempo a conhecê-la, graças aos recursos de segurança do Bumble.",
      "UMA FORMA MAIS SEGURA  DE TE LIGARES",
      "Depois de conheceres alguém na vida real, através do Bumble, podes continuar a conversa na app, falando das coisas que têm em comum, sejam elas a paixão que têm por café ou a loucura que têm por gatos.",
      "CONTINUA A CONVERSAR",
      "Queres fazer uma pausa? Experimenta o modo Não perturbar",
      "Sim, podes ir a \"definições\" ou à tua fila, e desativar o modo Não perturbar quando quiseres.",
      "Posso desativar o modo Não perturbar antes da data que estipulei?",
      "Vai a \"definições\", toca em Não perturbar e escolhe por quanto tempo pretendes estar ausente. Quando quiseres voltar, desativa esse modo.",
      "Como se ativa o modo Não perturbar no perfil?",
      "Não. No modo Não perturbar, o recurso de votos e as conversas ficam em pausa. Se, entretanto, quiseres votar novamente, verás uma mensagem com o tempo de duração da tua pausa e a opção para a desativares.",
      "Posso votar e conversar no modo Não perturbar?",
      "As ligações com quem falaste antes podem ver que estás \"ausente\", se tiveres definido esse estado. Caso não o tenhas feito, elas verão as mensagens que trocaram na caixa de entrada, como se nada tivesse mudado.",
      "O que veem as ligações quando estou no modo Não perturbar?",
      "Tens total controlo sobre as tuas atividades no Bumble e podes desativar a plataforma sempre que quiseres.",
      "Podes informar as ligações da tua situação, definindo o teu estado. Assim, as tuas ligações não ficam a pensar que <a href={{ghosted_article_url}}>desapareceste</a>. Além disso, o resto é automatizado, por isso não precisas de enviar mensagens adicionais.",
      "Coloca uma pausa nos encontros, sem perder ligações ou conversas.",
      "Podes encontrar-te (ou desligar-te) como queres",
      "Informa as ligações",
      "Põe uma pausa nas atividades, mas não nas ligações",
      "Porque é que adoramos o modo Não perturbar?",
      "Abre a aplicação do Bumble, vai ao perfil e toca na roda dentada das definições no canto superior direito. Nas definições, toca em Não perturbar e escolhe por quanto tempo pretendes estar ausente. Podes ocultar o perfil por 24 horas, 72 horas, uma semana ou indefinidamente.{{__EOL__}}{{__EOL__}}Não te esqueças: as ligações com quem não conversaste vão expirar enquanto estiveres no modo Não perturbar. Se optares por definir um estado, as pessoas com quem tiveste uma conversa vão poder ver que estás ausente.",
      "Como funciona o modo Não perturbar no Bumble?",
      "Às vezes é difícil dar conta de tudo. É aqui que o modo Não perturbar pode ajudar. Põe uma pausa na conta do Bumble e utiliza-a só quando queres.",
      "Modo Não Perturbar ativado no Bumble",
      "Com o modo Não perturbar podes desativar a conta temporariamente quando precisas de uma pausa do mundo dos encontros. Podes continuar a conversar com as ligações existentes, mas o teu perfil deixa de aparecer às pessoas até que o decidas mostrar. Quando ativas o modo Não perturbar, não perdes as informações do perfil, nem as ligações que já fizeste.",
      "Desativa o perfil do Bumble",
      "Quando estiveres no modo Não perturbar, podes informar as ligações de que estás numa pausa, atualizando o estado. Escolhe entre “A viajar”, “A focar-me no trabalho”, \"Num detox digital\" ou \"A dedicar-me ao autocuidado\". Estamos aqui para o que precisares.",
      "Definir um motivo de ausência",
      "O modo Não perturbar desativa a conta do Bumble (ou {{page_partner_name_bff}}). As tuas ligações não saberão que o ativaste, a menos que lhes digas. Se quiseres sair do modo Não perturbar antes da data que determinaste, só tens de ir às definições e tocar em “Desativar modo Não perturbar”. É muito fácil.",
      "Pausar as conversas",
      "Experimenta o SuperSwipe no Bumble",
      "Quantos quiseres! Os utilizadores do {{service_level_lexeme_name}} obtêm {{num}} [[superswipe:num]] todas as semanas, mas podes carregar o teu saldo sempre que quiseres. Os membros sem assinatura podem comprar pacotes com SuperSwipes.",
      "Quantos SuperSwipes posso enviar no Bumble?",
      "Quando recebes um SuperSwipe, recebes também uma notificação. Além disso, podes ver uma indicação do apreço dessa pessoa no seu perfil.",
      "Como descubro se alguém fez SuperSwipe no meu perfil?",
      "Gostas de alguém a sério? Quebra o gelo de forma original. Envia um SuperSwipe para mostrar o teu interesse e passar logo ao que interessa.",
      "SuperSwipe no Bumble",
      "Nem sempre é fácil dar nas vistas, mas o SuperSwipe ajuda-te a causar uma ótima primeira impressão.{{__EOL__}}{{__EOL__}}Quando utilizas um SuperSwipe, a pessoa é notificada. Depois, passas para o início da fila com uma indicação no teu perfil. Se gostarem de ti, podem começar a conversar.",
      "O que é um SuperSwipe?",
      "Ter coragem e dar nas vistas",
      "Começar mais conversas",
      "Fazer mais ligações",
      "O SuperSwipe ajuda-te a...",
      "Se tiveres o <a href={{bumble_boost_url}}>Bumble {{service_level_lexeme_name}}</a> ou o Bumble {{service_level_lexeme_name_one}}, recebes {{num}} [[superswipe:num]] gratuitos por semana. Além disso, todos os membros podem comprar pacotes com um máximo de {{num_two}} [[superswipe:num_two]] no separador do perfil. Se tiveres {{service_level_lexeme_name_three}}, recebes {{num_three}} [[superswipe:num_three]] por semana.{{__EOL__}}{{__EOL__}}É fácil usar os SuperSwipes, quando vês alguém do teu agrado, toca no ícone da estrela no canto inferior do seu perfil.",
      "Como se usa o SuperSwipe?",
      "Encontra-te onde quer que estejas com o Modo Viagem do Bumble",
      "O Modo Viagem é disponibilizado aos membros do <a href={{bumble_premium_url}}>{{service_level_lexeme_name}}</a>. Ativa-o, para que a tua fila te mostre novas caras na cidade que escolheste.",
      "Como é que se usa o Modo Viagem?",
      "Em princípio, sim. As restrições de segurança podem mudar ao longo do tempo, mas o Modo Viagem encontra-se disponível na maioria dos destinos.",
      "Posso usar o Modo Viagem em qualquer lugar?",
      "O Modo Viagem coloca-te no meio da cidade que escolheste. O teu perfil indicará que tens o Modo Viagem ativado, e assim, os outros membros sabem que estás de visita ou a planear visitar.",
      "A fazer as malas para umas férias ou a visitar uma nova cidade em trabalho? Ativa o Modo Viagem do Bumble e encontra-te onde quer que estejas.",
      "Modo Viagem no Bumble",
      "O Modo Viagem é uma ferramenta para fazeres ligações enquanto estás fora. Define a localização para qualquer lugar do mundo e faz encontros onde quer que as tuas aventuras te levem.",
      "O que é o Modo Viagem?",
      "Ninguém conhece uma terra melhor do que quem lá mora. O Modo Viagem ajuda-te a criar ligações com pessoas que podem tornar a tua viagem ainda mais especial.",
      "Define a tua localização até sete dias antes de ires, para teres tempo de fazer planos e encontrar ligações.",
      "Pensa além de uma viagem de praia: podes estar a visitar família, a viajar em trabalho ou a explorar uma cidade nova. Encontra romance onde quer que estejas.",
      "Descobre os melhores sítios para encontros perto de ti",
      "Aventura-te",
      "Cria ligações duradouras",
      "Motivos para adorar o Modo Viagem",
      "O Modo Viagem é disponibilizado aos membros do <a href={{bumble_premium_url}}>{{service_level_lexeme_name}} e do {{service_level_lexeme_name_two}} </a> no Bumble. Toca na roda dentada das definições, no canto superior direito do perfil, e desliza até veres o Modo Viagem. Escolhe a tua nova localização para começares a ver pessoas nessa área. O teu perfil mostrará às potenciais ligações que o Modo Viagem está ativado.",
      "Como funciona o Modo Viagem?",
      "Usar já",
      "Aqui, a amabilidade é sexy. Tu, exatamente como és, és aceite e, como sempre, as mulheres dão o primeiro passo.",
      "É aqui que se Dá o Primeiro Passo™",
      "As relações saudáveis são cruciais para uma vida positiva e produtiva. O Bumble foi criado para facilitar essas ligações, quer procures um encontro, amigos ou contactos profissionais.",
      "O impacto do Bumble",
      "Defendemos a integridade, a amabilidade, a igualdade, a confiança e o respeito em todas as fases da relação. Não só acolhemos todas as orientações, como também as celebramos — quer aqui estejas para encontrar amor ou simplesmente para te divertires.",
      "Os valores do Bumble",
      "No Bumble, as mulheres dão o primeiro passo ou escolhem o Opening Move para iniciar a conversa. Isto muda as dinâmicas de poder antiquadas e encoraja a igualdade desde o início.",
      "Como funciona o Bumble",
      "Sobre nós",
      "Descarregar já",
      "É melhor na app.",
      "Recursos que tornam os encontros online mais agradáveis",
      "12 de fevereiro, 2024",
      "Como aumentar a intimidade emocional na relação",
      "25 de janeiro, 2024",
      "Como usar o Bumble quando nunca usaste uma app de encontros",
      "5 de fevereiro, 2024",
      "Deception Detector™",
      "Últimas notícias do mundo dos encontros",
      "Faz uma pausa com o <b>Não Perturbar</b>. Quando quiseres voltar, sabes onde nos encontrar.",
      "Faz uma pausa",
      "Usa as <b>videochamadas</b> e as <b>conversas em áudio</b> para te aproximares das ligações sem saíres de casa.",
      "Di-lo em voz alta",
      "Ver mais",
      "Seleciona <b>Opening Moves</b> para dares a oportunidade a alguém de iniciar uma conversa. Assim, não tens tu de o fazer.",
      "Mais encontros com menos esforço",
      "Encontra a tua felicidade em qualquer parte do mundo com <b>o Modo Viagem.</b>",
      "Aonde vamos?",
      "O perfil passou a prova dos nove? Diz-lhe com um <b>SuperSwipe</b>.",
      "Dá nas vistas",
      "Utiliza o <b>Compliments</b> para te destacares das multidões.",
      "Fá-los corar",
      "Usa o <b>Modo Invisível</b> para ocultar o perfil do patrão, ex ou dos parentes.",
      "Oculta o perfil",
      "Encontros como os queres",
      "Uns meses mais tarde, ela conheceu também uma das suas damas de honor",
      "Hannah conheceu o seu atual marido no Bumble.",
      "Antes de construirem a sua casa juntos, Carène e You-Liang conheceram-se no Bumble. As fotos de viagem de Carène chamaram a atenção de You-Liang.",
      "Carène e You-Liang",
      "Brian e Kaci trabalharam num país estrangeiro ao mesmo tempo — mas foi no Bumble que se conheceram",
      "Brian e Kaci",
      "Se funcionou para eles, também pode funcionar para ti",
      "Dá o próximo passo",
      "Ver novidades",
      "Tu mereces melhor. Por isso, criámos ótimas formas de fazer mais encontros com menos stress.",
      "Não te contentes com menos do que mereces",
      "Sobre o Bumble",
      "Somos a única app que melhora os encontros, dando prioridade às experiências das mulheres. Uma mulher contente, alegra muita gente.",
      "Dá o primeiro passo™",
      "Encontra alguém com quem te queres mesmo encontrar e depois dá o primeiro passo. Cria ligações genuínas, vibra com interesses em comum e, acima de tudo, diverte-te.",
      "Conhece alguém com o Bumble Date",
      "Encontra amizades no mundo do trabalho. Liga-te a outros profissionais para encontrares o teu próximo emprego, a um mentor ou encontra uma nova carreira.",
      "Dá passos largos na carreira com o Bumble Bizz",
      "Conhece alguém como tu. Ou diferente de ti. Cria amizades e descobre novas atividades para fazerem juntos — tanto no teu país como no estrangeiro.",
      "Encontra novas amizades no Bumble For Friends",
      "Somos mais do que romance",
      "O Bumble é a app de encontros onde as mulheres dão o primeiro passo. É a app que mudou como as pessoas se encontram, criam relações significativas e fazem networking. Descarrega já.",
      "Bumble no {{social_network}}",
      "Saber mais",
      "Instala o Bumble a partir da App Store ou do Google Play e inicia sessão com a mesma conta que usaste no Bumble web.{{__EOL__}}{{__EOL__}}Faz scan ao código QR abaixo com o teu telemóvel ou tablet para começar.{{__EOL__}}{{__EOL__}}As tuas ligações e conversas estão à tua espera na app. 💛",
      "Obtém a aplicação",
      "Para podermos continuar a trazer-te a melhor experiência e os mais eficazes recursos de segurança, o Bumble agora está disponível apenas como app.",
      "O Bumble agora é apenas uma app.",
      "Nunca percas uma conexão",
      "Ligar sem ter que compartilhar número",
      "Confia que as tuas ligações são genuínas.",
      "Recebe notificações em tempo real para não perderes nenhuma mensagem.",
      "Usa as nossas chamadas de voz e vídeo na app para ajudar a passar de match para a vida real, com segurança.",
      "Conversa confortavelmente com membros verificados usando a verificação fácil de foto e documento de identificação na app.",
      "Por que mudar para o app do Bumble?",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life",
      "Premium+",
      "Página não encontrada.",
      "Contacto",
      "Ups, ocorreu um problema",
      "(abre em nova janela)",
      "FAQ",
      "Política de Cookies",
      "Premium",
      "Blogue do Bumble",
      "Vagas",
      "Chat",
      "Cidades",
      "Gerir cookies",
      "Copyright (c) 2006 - presente. Bumble, todos os direitos reservados.",
      "Relatório de Relacionamentos com Confiança",
      "A Apple e o logótipo da Apple são marcas registadas da Apple Inc.{{__EOL__}}Google Play é uma marca comercial da Google LLC.",
      "Instalar",
      "Facebook",
      "Siga-nos",
      "Centro de Apoio",
      "Instagram",
      "Idioma",
      "LinkedIn",
      "Bumble é parte da Bumble Inc.",
      "Política de Privacidade",
      "Centro de Segurança",
      "Mapa do Site",
      "Sobre a Lei contra a escravidão moderna",
      "Termos e condições",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "Compliments": {
            "plural": [
                  "elogios"
            ],
            "singular": [
                  "elogio"
            ]
      },
      "day": {
            "plural": [
                  "dias"
            ],
            "singular": [
                  "dia"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mês"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "superswipe": {
            "plural": [
                  "SuperSwipes"
            ],
            "singular": [
                  "SuperSwipe"
            ]
      },
      "year": {
            "plural": [
                  "anos"
            ],
            "singular": [
                  "ano"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
